import React from 'react';
import { Flex } from '@components/Flex';
import { Columns } from '@components/Columns';
import { NewFlag } from '@components/NewFlag';
import { CTALink } from '@components/CTALink';
import { getCreateWeddingUrl } from '@utils/urlHelpers.util';
import { CloudImage } from '@components/CloudImage';
import {
  DisplayAboveMobile,
  DisplayOnMobile,
  SectionWrapper,
  StyledRightCloudImage,
  StyledRightMobileCloudImage,
  StyledLeftCloudImage,
  StyledColumns,
  StyledTextPairing,
} from './ThankYouNotes.styles';
import { registryPageData } from '@data-ts/pages/registry';

const { thankYouNotes } = registryPageData;

export const ThankYouNotes: React.FC = () => {
  return (
    <SectionWrapper paddingTop={[9, 0]} alignItems={['flex-start', 'center']} as="section" id="RegistryThankYouNotes">
      <DisplayAboveMobile>
        <StyledRightCloudImage src="registry-v2/thank-you-notes/right_corner_v2.png" width="46%" />
        <StyledLeftCloudImage src="registry-v2/thank-you-notes/left_corner_v2.png" width="27%" />
      </DisplayAboveMobile>
      <DisplayOnMobile>
        <StyledRightMobileCloudImage src="registry-v2/thank-you-notes/mobile_right_corner_v2.png" width="100%" />
        <StyledLeftCloudImage src="registry-v2/thank-you-notes/mobile_left_corner_v2.png" width="100%" />
      </DisplayOnMobile>
      <StyledColumns centered>
        <Columns.Column width={6}>
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems={['center', 'flex-start']}
            style={{ height: '100%' }}
            paddingBottom={[0, 9]}
          >
            <NewFlag
              title={thankYouNotes.flagTitle}
              titleColor="accentBlue4"
              flagColor="white"
              flagBackgroundColor="accentBlue4"
              belowSm={{ flagColor: 'white', flagBackgroundColor: 'accentBlue4' }}
            />
            <Flex marginTop={[0, 2]} alignItems="flex-start" flexDirection="column">
              <StyledTextPairing
                titleVariant="hed40"
                titleColor="neutra6"
                titleTagName="h3"
                title={thankYouNotes.title}
                body={thankYouNotes.body}
                bodyVariant="featureCopy17"
                bodyColor="neutra5"
                bodyMaxWidth="480px"
                marginBottom={6}
                textAlign={['center', 'left']}
              />
              <Flex justifyContent={['center', 'flex-start']} style={{ width: '100%' }}>
                <CTALink
                  id="registryThankYouNotesCTA"
                  href={getCreateWeddingUrl('registry')}
                  variant="primary"
                  typography="featureHed17"
                  hasChevron
                >
                  {thankYouNotes.getStartedCta}
                </CTALink>
              </Flex>
            </Flex>
          </Flex>
        </Columns.Column>
        <Columns.Column width={6}>
          <Flex flexDirection="column" justifyContent="center" alignItems={['center', 'flex-start']} paddingTop={9}>
            <DisplayAboveMobile>
              <CloudImage src="registry-v2/thank-you-notes/phone-v2.png" width="100%" />
            </DisplayAboveMobile>
            <DisplayOnMobile>
              <CloudImage src="registry-v2/thank-you-notes/mobile_phone.png" width="100%" />
            </DisplayOnMobile>
          </Flex>
        </Columns.Column>
      </StyledColumns>
    </SectionWrapper>
  );
};
